import AbstractCommand from "../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameConfig from "../model/GameConfig";
import SaveModel from "../model/SaveModel";


export default class StartGameCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveModel} saveModel 
     * @param {GameConfig} gameConfig 
     */
    constructor(dispatcher, saveModel, gameConfig) {
        super(dispatcher);

        this.execute = function(event) {
            this.gotoScreen(SkinKeys.GAME_SCREEN);
        };
    };

}